<template>
    <div>
        <container :aside="'police'">
            <div class="warp">
                <div class="head base-head">
                    <el-row>
                        <el-col :span="16" :offset="0">
                            <el-button type="primary" size="small" @click="add">添加用户</el-button>
                        </el-col>
                        <el-col :span="8" :offset="0">
                            <div class="search-box">
                                <el-input class="search-input" v-model="keyword" placeholder="姓名/手机号" size="small" clearable @input="onsearch"></el-input>
                                <span class="el-icon-search"></span>
                            </div>
                        </el-col>
                    </el-row>
                    
                </div>
                
                <div class="table-box">
                    <el-table :data="tabledata" border stripe size="mini" v-loading="loading">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="姓名" prop="name"></el-table-column>
                        <el-table-column label="手机号" prop="telephone"></el-table-column>
                        <el-table-column label="等级" prop="mode">
                            <template slot-scope="s">
                                <p>{{modearr[s.row.mode]}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="辖区" prop="name">
                            <template slot-scope="s">
                                <p class="text">
                                    <span v-for="(item, index) in s.row.security" :key="index">{{item}}</span>
                                </p>
                            </template>
                        </el-table-column>
                        <el-table-column label="上报数量" prop="total"></el-table-column>
                        <el-table-column label="上次登录时间" prop="">
                            <template slot-scope="s">
                                <p>{{s.row.logintime}}</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" fixed="right" width="240">
                            <template slot-scope="s">
                                <el-button-group>
                                    <el-button type="primary" size="mini" icon="el-icon-s-home" @click="edit(s.row)">编辑</el-button>
                                    <el-button type="success" v-if="s.row.forbidden" size="mini" @click="setUserState(s.row._id, false, s.$index, s.row)">恢复</el-button>
                                    <el-button type="warning" v-else size="mini" @click="setUserState(s.row._id, true, s.$index, s.row)">禁用</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    small
                    :current-page="pageNo"
                    :total="total" background>
                </el-pagination>
                <router-view></router-view>
            </div>
        </container>
    </div>
</template>

<script>
import Container from '../../components/container.vue'
export default {
    components: {
        Container,
    },
    data() {
        return {
            tabledata: [],
            pagesize: 15,
            pageNo: 1,
            total: 0,
            keyword: '',
            loading: false,
            modearr: {
                city: '城市',
                district: '区',
                police: '派出所',
                community: '社区',
            },
        }
    },
    mounted () {
        this.getTableData();
    },
    methods: {
        onsearch() {
            this.pageNo = 1;
            this.getTableData();
        },
        setUserState(uid, state, index, item){
            var that = this;
            var params = {
                uid, state
            }
            this.$api.forbidden_userv1(params).then(data=>{
                this.$message({
                    message: data,
                    type: 'success'
                });
                item.forbidden = state;
                that.$set(that.tabledata, index, item);
                that.$forceUpdate();
            })
        },
        getTableData() {
            var that = this;
            var params = {
                pageNo: this.pageNo,
                pagesize: this.pagesize,
                keyword: this.keyword,
            };
            this.$api.listUserV1(params).then(data=>{
                let {list, total} = data;
                that.tabledata = list;
                that.total = total;
            })
        },
        add() {
            this.$router.push({path: '/account/detail'})
        },
        edit(item) {
            var id = item.id;
            this.$router.push({path: '/account/detail', query:{id}})
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        beforeRouteUpdate(to, from ,next) {
            console.log(to, from ,next);
        },
    },
    watch: {
        $route(newValue, oldValue) {
            if (oldValue&&oldValue.path=='/account/detail') this.getTableData();
        }
    },
}
</script>

<style lang="scss" scoped>
.search-input{
    /deep/.el-input__inner{
        border: none;
    }
}
.out-table-box{
    position: absolute;
    bottom: -99999999px;
}
</style>